import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorModule, ToolbarSettingsModel, RichTextEditor, RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { FormsModule } from '@angular/forms';
import { TicketService } from '../../services/ticket.service';
import { MessageStackService } from '../../services/message-stack.service';
import { FileAttachmentService } from '../../services/file-attachment.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-message-stack',
  imports: [RichTextEditorModule, NgIf, FormsModule],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, DatePipe],
  templateUrl: './message-stack.component.html',
  styleUrl: './message-stack.component.css'
})

export class MessageStackComponent implements OnInit, OnDestroy {
  replyBox: boolean = false
  @ViewChild('rte') public rteObj!: RichTextEditorComponent;
  private listenersAdded = false;
  
  // Current user information
  currentUserName: string = '';
  currentUserEmail: string = '';

  public insertImageSettings = {
    // allowedTypes: ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp'],
    // display: 'inline',
    // width: 'auto',
    // height: 'auto',
    cssClass: 'uploaded-image'
  };

  
  defaultRTE!: RichTextEditor;
  public tools: ToolbarSettingsModel = {
    items: [
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'LowerCase', 'UpperCase', '|',
      'SuperScript', 'SubScript', '|',
      'Alignments', '|',
      'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|',
      'CreateLink', 'Image', '|',
      'CreateTable', '|',
      'ClearFormat', 'Print', '|',
      'Undo', 'Redo', '|',
      'FullScreen'
    ], 
  };
  replyMessage: string = ''
  @Input() ticketID!: any
  @Input() participantsList: string[] = []
  @ViewChild('fileInput') fileInput: any;
  uploadedFilesArray: File[] = [];
  messageStack: any;
  messageStackExpanded: boolean = true;
  isButtonHovered: boolean = false;
  safeEmailBody: SafeHtml | undefined;
  ALLOWED_FILES: { [key: string]: string } = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    tiff: "image/tiff",
    tif: "image/tiff",
    webp: "image/webp",
    svg: "image/svg+xml",
    ico: "image/x-icon",
    heic: "image/heic",
    heif: "image/heif",
    jfif: "image/jpeg",
    pjpeg: "image/pjpeg",
    pjp: "image/pjpeg",
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    txt: "text/plain",
    csv: "text/csv",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    aac: "audio/aac",
    flac: "audio/flac",
    m4a: "audio/mp4",
    mp4: "video/mp4",
    avi: "video/x-msvideo",
    mov: "video/quicktime",
    wmv: "video/x-ms-wmv",
    flv: "video/x-flv",
    mkv: "video/x-matroska",
    webm: "video/webm",
    zip: "application/zip",
    rar: "application/vnd.rar",
    "7z": "application/x-7z-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
  };

  expandMessageStack() {
    this.messageStackExpanded = true;
  }

  fileUploadErrorMessage: string = '';

  handleFileSelect(event: any) {
    this.fileUploadErrorMessage = '';

    const files = Array.from(event.target.files) as File[];
    const maxTotalSize = 25 * 1024 * 1024;

    const validFiles: File[] = [];
    const invalidFiles: string[] = [];

    for (const file of files) {
      const ext = file.name.split('.').pop()?.toLowerCase();
      const mime = file.type;

      if (ext && this.ALLOWED_FILES[ext] && this.ALLOWED_FILES[ext] === mime) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      this.fileUploadErrorMessage = `These files are not allowed:\n${invalidFiles.join(', ')}`;
      return;
    }

    const currentTotalSize = this.uploadedFilesArray.reduce((sum, file) => sum + file.size, 0);
    const newFilesTotalSize = validFiles.reduce((sum, file) => sum + file.size, 0);
    const combinedTotalSize = currentTotalSize + newFilesTotalSize;

    if (combinedTotalSize > maxTotalSize) {
      this.fileUploadErrorMessage = 'Total attachments size must not exceed 25 MB.';
      return;
    }

    this.uploadedFilesArray = [...this.uploadedFilesArray, ...validFiles];
    this.fileUploadErrorMessage = '';
  }

  replyToMessage() { 

    if(this.fileUploadErrorMessage === '' ) {
      this.ticketService.replyOnTicket(this.ticketID, this.replyMessage, this.uploadedFilesArray).subscribe({
        next: () => {
          this.ticketService.getTicketDetails(this.ticketID).subscribe({
            next: (response) => {
              this.messageStack = response
              this.messageStack.forEach((email: any) => {
                email.email_formatted_date = this.dateType.transform(email.email_date, 'MMMM dd, yyyy')
                email.email_formatted_time = this.dateType.transform(email.email_date, 'h:mm a')
                email.reply_box_flag = false
                email.email_body = this.sanitizer.bypassSecurityTrustHtml(email.email_body)
              })
            }
          })
          
        },
        error: (error) => {
          console.error(error)
        }
      })
    }
    
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  showReplyBox(email: any) {
    this.replyMessage = '';
    this.fileUploadErrorMessage = ''
    email.reply_box_flag = !email.reply_box_flag
  }

  removeFileFromUploadedArray(file: File) {
    this.uploadedFilesArray = this.uploadedFilesArray.filter(f => f !== file);

    const maxTotalSize = 20 * 1024 * 1024; 
    const totalSize = this.uploadedFilesArray.reduce((sum, f) => sum + f.size, 0);

    if (totalSize > maxTotalSize) {
      this.fileUploadErrorMessage = 'Total attachments size must not exceed 25 MB.';
    } else {
      this.fileUploadErrorMessage = '';
    }    
  }

  ngOnInit(): void {
    // Get current user information from sessionStorage
    this.currentUserName = sessionStorage.getItem('userName') || 'Current User';
    this.currentUserEmail = sessionStorage.getItem('emailAddress') || 'currentuser@company.com';
    
    this.messageStack = this.messageStackService.messageStack
    this.messageStack.forEach((email: any) => {
      email.email_formatted_date = this.dateType.transform(email.email_date, 'MMMM dd, yyyy')
      email.email_formatted_time = this.dateType.transform(email.email_date, 'h:mm a')
      email.reply_box_flag = false
      email.email_body = this.sanitizer.bypassSecurityTrustHtml(email.email_body)
    })

    if (this.messageStack.length > 5) {
      this.messageStackExpanded = false;
    }
  }

  constructor( private readonly dateType: DatePipe, private readonly ticketService: TicketService, private readonly messageStackService: MessageStackService, private readonly fileAttachmentService: FileAttachmentService, private readonly sanitizer: DomSanitizer, private http: HttpClient) {
    this.messageStack = []  
  }
  ngOnDestroy(): void {
    this.listenersAdded = false;
  }

  downloadAttachment(fileName: string) {
    this.fileAttachmentService.donwloadFile(fileName).subscribe({
      next: (response) => {
        if (response?.secure_url) {
        window.open(response.secure_url, '_blank');
      } else {
        alert('Download link not available.');
      }
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

  onImageSelected(args: any): void {
    const file = args.filesData[0].rawFile;
    console.log('Selected image file:', file);

    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('Missing auth token');
      return;
    }

    const formData = new FormData();
    formData.append('files', file);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${authToken}`
    });

    this.http.post<any>(
      'https://ticketingtool-dev.teamleaseregtech.com/api/inline_files_upload/',
      formData,
      { headers }
    ).subscribe({
      next: (res) => {
        console.log('Image upload response:', res);
        this.rteObj.focusIn();
        const uploadedUrl = res.files?.[0];
        if (uploadedUrl) {
          const imageHtml = `<img src="${uploadedUrl}" 
                            alt="Uploaded Image" 
                            class="uploaded-image" 
                            style="
                              max-width: 500px !important;
                              min-width: 100px !important;
                              height: auto !important;
                              display: block !important;
                              margin: 10px 0 !important;
                              border-radius: 4px !important;
                              display: none !important;"
                            >`;
        
        this.rteObj.executeCommand('insertHTML', imageHtml);

          // this.rteObj.executeCommand('insertImage', {
          //   url: uploadedUrl,
          //   width: {
          //     minWidth: '100px',
          //     maxWidth: '500px'
          //   },
          //   height: {
          //     minHeight: '100px',
          //     maxHeight: '500px'
          //   },
          //   altText: ''
          // });
        } else {
          console.error('Upload succeeded but no image URL returned.');
        }
      },
      error: (err) => {
        console.error('Image upload failed:', err);
      }
    });
  }

  private bindPasteAndDropListeners(): void {
    const rteContent = this.rteObj.element.querySelector('.e-rte-content') as HTMLElement;
    if (!rteContent) return;

    // Avoid duplicate bindings
    if ((rteContent as any)._listenersBound) return;
    (rteContent as any)._listenersBound = true;

    console.log('[BindListeners] Binding paste and drop listeners.');

    rteContent.addEventListener('paste', (event: ClipboardEvent) => {
      const items = event.clipboardData?.items;
      if (items) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type.startsWith('image')) {
            const file = item.getAsFile();
            if (file) {
              event.preventDefault();
              this.uploadAndInsertImage(file);
            }
          }
        }
      }
    });

    rteContent.addEventListener('drop', (event: DragEvent) => {
      const files = event.dataTransfer?.files;
        if (files?.length) {
          for (const file of files) {
            if (file.type.startsWith('image/')) {
              event.preventDefault();
              this.uploadAndInsertImage(file);
            }
          }
        }
      });
    }


  onRteCreated(): void {
    setTimeout(() => {
      // if (!this.rteObj || !this.rteObj.element || this.listenersAdded) return;

      if (!this.rteObj || !this.rteObj.element) return;

      const observer = new MutationObserver(() => {
        this.bindPasteAndDropListeners();
      });

      const contentArea = this.rteObj.element.querySelector('.e-rte-content');
      if (contentArea) {
        observer.observe(contentArea, { childList: true, subtree: true });
        this.bindPasteAndDropListeners(); // initial bind
      }

      const rteContent = this.rteObj.element.querySelector('.e-rte-content') as HTMLElement;
      console.log('RTE content element:', rteContent);
      if (!rteContent) return;

      // 📌 Prevent double registration
      this.listenersAdded = true;
      console.log('Adding event listeners...');


      // 📋 Handle Paste
      // rteContent.addEventListener('paste', (event: ClipboardEvent) => {
      //   console.log('Paste event triggered');

      //   const items = event.clipboardData?.items;
      //   console.log('--------------------------')
      //   console.log(items)
      //   if (items) {
      //     for (let i = 0; i < items.length; i++) {
      //     const item = items[0];
      //     console.log('Paste item type:', item.type);
      //     if (item.type.startsWith('image')) {
      //       const file = item.getAsFile();
      //       if (file) {
      //         console.log('Image file found in paste, calling uploadAndInsertImage');
      //         event.preventDefault();
      //         this.uploadAndInsertImage(file);
      //       }
      //     }
      //     }
      //   }
      // });
 
      // 🖱️ Handle Drag-Drop
      // rteContent.addEventListener('drop', (event: DragEvent) => {
      //   const files = event.dataTransfer?.files;
      //   if (files?.length) {
      //     for (const file of files) {
      //       if (file.type.startsWith('image/')) {
      //         event.preventDefault();
      //         this.uploadAndInsertImage(file);
      //       }
      //     }
      //   }
      // });
    }, 100); // Give Angular time to render
  }

  uploadAndInsertImage(file: File) {
    console.log('Uploading image:', file);
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('Missing auth token');
      return;
    }

    const formData = new FormData();
    formData.append('files', file);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${authToken}`
    });

    this.http.post<any>(
      'https://ticketingtool-dev.teamleaseregtech.com/api/inline_files_upload/',
      formData,
      { headers }
    ).subscribe({
      next: (res) => {
        this.rteObj.focusIn();
        const uploadedUrl = res?.files?.[0];
        if (uploadedUrl) {
          const imageHtml = `<img src="${uploadedUrl}" 
                            alt="Uploaded Image" 
                            class="uploaded-image" 
                            style="
                              max-width: 500px !important;
                              min-width: 100px !important;
                              height: auto !important;
                              display: block !important;
                              margin: 10px 0 !important;
                              border-radius: 4px !important;
                              display: none !important;"
                            >`;
        
        this.rteObj.executeCommand('insertHTML', imageHtml);
        } else {
          console.error('Upload succeeded but no URL returned.');
        }
      },
      error: (err) => {
        console.error('Image upload failed:', err);
      }
    });
  }
}
